import {AssetGalleryPref} from '@netx/core-asset-gallery/constants';
import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import type {SearchSort} from '../types';
import {getDefaultSortField} from './getDefaultSortField';

export type GetUserSortParams = {
	sortFieldPrefKey?: string;
	sortOrderPrefKey?: string;
	defaultSortField?: string;
	defaultSortOrder?: number;
};

/**
 * Get user preferred sort field/order
 * @returns User preferred sort field/order
 */
export const getUserSort = ({
	defaultSortField,
	defaultSortOrder,
	sortFieldPrefKey = isBrandPortal()
		? AssetGalleryPref.SORT_FIELD_PORTAL
		: AssetGalleryPref.SORT_FIELD,
	sortOrderPrefKey = isBrandPortal()
		? AssetGalleryPref.SORT_ORDER_PORTAL
		: AssetGalleryPref.SORT_ORDER,
}: GetUserSortParams = {}): SearchSort => {
	const sortOrder = getPreference(sortOrderPrefKey);
	let sortField = getPreference(sortFieldPrefKey);
	if (sortField === 'fileName') sortField = 'file';
	return {
		sortField: sortField || (defaultSortField ?? getDefaultSortField()),
		sortOrder: sortOrder != null ? parseInt(sortOrder) : defaultSortOrder ?? 0,
	};
};

export default getUserSort;
